import Image from '@atlaskit/image';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { BadgeCardWrapper } from './BadgeCardWrapper';

export interface Props {
  image: {
    src: string;
    alt: string;
  };
  badgeTitle: string;
  link: string;
  isPersonalView?: boolean;
  badgeType?: 'learning' | 'forums';
}

export const BadgeCard = ({
  image,
  badgeTitle,
  link,
  isPersonalView = false,
  badgeType = 'forums',
}: Props) => {
  function truncateString(input: string) {
    if (input.length > 65) {
      return input.substring(0, 65) + '...';
    }
    return input;
  }

  return (
    <BadgeCardWrapper
      isClickable={Boolean(link)}
      to={link}
      badgeTitle={badgeTitle}
      badgeType={badgeType}
      isPersonalView={isPersonalView}
    >
      <div css={imageContainerStyles}>
        <Image src={image.src} alt={image.alt} css={imageStyles} />
      </div>
      <div css={contentContainerStyles}>
        <p css={badgeTitleStyles}>{truncateString(badgeTitle)}</p>
      </div>
    </BadgeCardWrapper>
  );
};

const imageContainerStyles = css({
  flexShrink: 0,
  width: '65px',
  height: '65px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  borderRadius: '50%',
});

const imageStyles = css({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: '50%',
});

const contentContainerStyles = css({
  marginLeft: '16px',
});

const badgeTitleStyles = css({
  fontSize: '16px',
  fontFamily: token('font.family.brand.heading'),
  fontWeight: token('font.weight.semibold'),
  lineHeight: '24px',
  wordBreak: 'break-word',
  margin: 0,
});
